import { useState } from 'react';
import { getApiBaseURL } from '../services/api';

/**
 * Хук для API запросов чата
 */
export const useChatAPI = (apiKey, apiUrl) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const getHeaders = () => {
    const headers = {
      'Content-Type': 'application/json',
    };
    if (apiKey) {
      headers['X-API-Key'] = apiKey;
    }
    return headers;
  };

  const sendMessage = async (message, onSuccess, onError) => {
    if (!message.trim() || isLoading) {
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const apiBaseURL = getApiBaseURL(apiUrl);
      const response = await fetch(`${apiBaseURL}/api/v1/chat`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({
          message: message.trim(),
        }),
      });

      if (!response.ok) {
        const errorData = await response
          .json()
          .catch(() => ({ detail: 'Ошибка сервера' }));
        throw new Error(errorData.detail || `Ошибка ${response.status}`);
      }

      const data = await response.json();
      const aiResponse = data.message || data.body?.message || 'Нет ответа';
      const model = data.model || data.body?.model;

      if (onSuccess) {
        onSuccess(aiResponse, model);
      }
    } catch (error) {
      console.error('Error sending message:', error);
      const errorMessage = error.message || 'Ошибка при отправке сообщения';
      setError(errorMessage);
      if (onError) {
        onError(errorMessage);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    sendMessage,
    setError,
  };
};

